//@ts-nocheck
import React from 'react';
import {DialogBody, DialogCloseTrigger, DialogContent, Portal} from '@chakra-ui/react';
import {ReactComponent as CloseIcon} from 'svg/close.svg';
import styles from './styles.module.scss';
import classNames from 'classnames';
import useWindowSize from 'hooks/useWindowSize';
import {BREAKPOINTS} from '../../constants';
import {FaArrowLeftLong} from 'react-icons/fa6';

const Dialog: React.FC<{
  children: React.ReactNode;
  isOpen: boolean;
  isAuth?: boolean;
  contentClassNames?: string;
  ref?: any;
  isForgot?: boolean;
  containerClassNames?: string;
}> = ({children, isOpen, isAuth, contentClassNames, ref, isForgot = false, containerClassNames}) => {
  const {width} = useWindowSize();
  const showLeftArrow = width < BREAKPOINTS.MD && isForgot;
  return (
    <Portal>
      <div
        className={classNames(styles.wrapper, containerClassNames, {[styles.active]: isOpen}, {[styles.auth]: isAuth})}
      >
        <DialogContent ref={ref}>
          <div className={classNames(styles.content, contentClassNames)}>
            <DialogCloseTrigger>
              <div className={classNames(styles.btn, {[styles.left]: showLeftArrow})}>
                {showLeftArrow ? <FaArrowLeftLong /> : <CloseIcon />}
              </div>
            </DialogCloseTrigger>
            <DialogBody>{children}</DialogBody>
          </div>
        </DialogContent>
      </div>
    </Portal>
  );
};

export default Dialog;
